var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      attrs: {
        left: "",
        origin: "center center",
        transition: "scale-transition",
        "data-testid":
          (_vm.params.testId ? _vm.params.testId + "__" : "") + "MenuItem"
      }
    },
    [
      _c(
        "v-btn",
        { attrs: { slot: "activator", icon: "" }, slot: "activator" },
        [_c("v-icon", { attrs: { color: "#526da5" } }, [_vm._v("more_vert")])],
        1
      ),
      _c(
        "v-list",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mostrarMenuAcciones,
              expression: "mostrarMenuAcciones"
            }
          ]
        },
        [
          _vm.params.onVerDetalle
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: { click: _vm.handleVerDetalle }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("info")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: { click: _vm.handleVerDetalle }
                    },
                    [_vm._v("Ver Detalle")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.params.onEditar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: { click: _vm.handleEditar }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("edit")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: { click: _vm.handleEditar }
                    },
                    [_vm._v("Editar")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.params.onEliminar
            ? _c(
                "v-list-tile",
                { staticStyle: { height: "40px" } },
                [
                  _c(
                    "v-list-tile-avatar",
                    { staticStyle: { "min-width": "35px" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { small: "", icon: "" },
                          on: { click: _vm.handleEliminar }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { small: "", color: "#526da5" } },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-list-tile-title",
                    {
                      staticStyle: {
                        cursor: "pointer",
                        "font-size": "13px",
                        color: "rgba(0,0,0,0.7)"
                      },
                      on: { click: _vm.handleEliminar }
                    },
                    [_vm._v("Eliminar")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }